
export class UnitConverter {

    static get SI_TO_LOCAL_COEFF () {

        return {
            'KG': 1, // kilogram
            'G': 1000, // gram
            'LB': 2.20462, // pound
            'OZ': 35.2739619496, // ounce
            'MM': 1, //millimeter
            'INCH': 0.03937007874015748, // inch
            'AC': 0.000247105, //acre
            'PAC': 4.0468564224, // per acre
            'HA': 0.0001, //hectare
            'ARE': 0.01, // are
            'PHA': 10000, // per hectare
            'MPS': 1, // meters per second
            'KMPH': 3.6, // kilometre per hour
            'MPH': 2.2369362920544025, // mile per hour
            'LPHA': 10000000, // litre per hectare
            'LP10ARE': 1000000, //litre per 10 are
            'KGPHA': 10000, // kilogram per hectare
            'KGP10ARE': 1000, // kilogram per 10 are
            'GAPAC': 1069066.36670416213, // gallon per acre
            'LPAC': 4046856.4224, // litre per acre
            'FLOZPAC': 136840614.3137533, // Fluid Ounce per acre
            'KGPAC': 4046.8564224, // kilogram per acre
            'GPAC': 4046856.4224, // gram per acre
            'LBPAC': 8921.791216197, // pound per acre
            'OZPAC': 142748.6594591527, // ounce per acre
            'L': 1000, // litre
            'GAL': 264.172052358148443, // gallon
            'FLOZ': 33814, // Fluid Ounce
            'BR_SOY_BPHA': 166.6666666666666667, //Brazil soyabean bags per hectare
            'US_CORN_BUSHELS_PER_ACRE': 159.3176700313371,  //US corn bushels per acre
            'CA_CORN_BUSHELS_PER_ACRE': 159.3176700313371,  //CA corn bushels per acre
            'CA_SOY_BUSHELS_PER_ACRE': 148.696520269950749, //CA soybean bushels per acre
            'US_SOY_BUSHELS_PER_ACRE': 148.696520269950749, //US soybean bushels per acre
            'CA_CANOLA_BUSHELS_PER_ACRE': 178.571428571428571428, // Canada canola bushels per acre
            'CA_WHEAT_BUSHELS_PER_ACRE': 148.696, // Canada Wheat bushels per acre
            'US_CANOLA_BUSHELS_PER_ACRE': 178.571428571428571428, // US canola bushels per acre
            'US_WHEAT_BUSHELS_PER_ACRE': 148.696, // US Wheat bushels per acre
            'TPHA': 10, // tonne per hectare
            'DTPHA': 100, // deci tonne per hectare
            'TNDMHAYY': 10, // tonne of dry matter per hectare
            'DEGREE': 0.0174532925199, // radian per degree
            'KUPHA': 10, // kilo units per hectare
            'KU': 0.001, // kilo units
            'BR_COTTON_ARROBA_PER_HECTARE': 666.6666666666667, // Brazil cotton arroba per hectare
            'T_AC': 4.0468564224, // tonnes per acre
            'BU48LB_AC': 185.870650337438436, // bushels per acre
            'BU30LB_AC': 297.393040539901498, // bushels per acre
            'BU32LB_AC': 278.805975506157654, // bushels per acre
            '60KG_HA': 166.6666666666666667 // 60KG per hectare (MD equivalent of BR_SOY_BPHA)
        };
    }

    static siToLocal (siValue, localUnitName, precision) {

        let value = siValue * UnitConverter.SI_TO_LOCAL_COEFF[localUnitName];

        if (!_.isUndefined(precision) && !_.isNull(precision)) {
            let adaptivePrecision = precision;

            // if number is too small for precision - increase precision to first non-zero digit
            while (value !== 0 && adaptivePrecision <= 6 && parseFloat(value.toFixed(adaptivePrecision)) === 0) {
                adaptivePrecision += 1;
            }

            value = Number(value.toFixed(adaptivePrecision));
        }

        let result = Number(value);

        if (!_.isNaN(result)) {
            return result;
        } else {
            return 0;
        }
    }

    static siToLocalRound (siValue, localUnitName) {

        return UnitConverter.siToLocal(siValue, localUnitName, 0);
    }

    static localToSi (localValue, localUnitName, precision) {

        let value = localValue / UnitConverter.SI_TO_LOCAL_COEFF[localUnitName];

        if (!_.isUndefined(precision) && !_.isNull(precision)) {
            value = value.toFixed(precision);
        }

        let result = Number(value);

        if (!_.isNaN(result)) {
            return result;
        } else {
            return 0;
        }
    }

    static localToString (localUnitName) {

        const mapping = {
            'TPHA': __('TPHA_STRING'),
            'DTPHA': __('DTPHA_STRING'),
            'TNDMHAYY': __('TNDMHAYY_STRING'),
            'BR_SOY_BPHA': __('BR_SOY_BPHA_STRING'),
            'US_CORN_BUSHELS_PER_ACRE': __('US_CORN_BUSHELS_PER_ACRE_STRING'),
            'CA_CORN_BUSHELS_PER_ACRE': __('CA_CORN_BUSHELS_PER_ACRE_STRING'),
            'CA_SOY_BUSHELS_PER_ACRE': __('CA_SOY_BUSHELS_PER_ACRE_STRING'),
            'US_SOY_BUSHELS_PER_ACRE': __('US_SOY_BUSHELS_PER_ACRE_STRING'),
            'CA_CANOLA_BUSHELS_PER_ACRE': __('CA_CANOLA_BUSHELS_PER_ACRE_STRING'),
            'CA_WHEAT_BUSHELS_PER_ACRE': __('CA_WHEAT_BUSHELS_PER_ACRE_STRING'),
            'US_CANOLA_BUSHELS_PER_ACRE': __('US_CANOLA_BUSHELS_PER_ACRE_STRING'),
            'US_WHEAT_BUSHELS_PER_ACRE': __('US_WHEAT_BUSHELS_PER_ACRE_STRING'),
            'BR_COTTON_ARROBA_PER_HECTARE': __('BR_COTTON_ARROBA_PER_HECTARE_STRING'),
            'T_AC': __('T_AC'),
            'BU48LB_AC': __('BU48LB_AC'),
            'BU30LB_AC': __('BU30LB_AC'),
            'BU32LB_AC': __('BU30LB_AC'),
            'LBPAC': __('LBPAC'),
            'KGPHA': __('KGPHA')
        };

        return mapping[localUnitName] || '';
    }

}


// WEBPACK FOOTER //
// ./shared/utils/UnitConverter.js